import { SPARK_STAGES } from "@/data/mock";
import { Sparkles, Send } from "lucide-react";

export default function PortalSpark() {
  return (
    <div className="grid gap-6 lg:grid-cols-3">
      <div className="panel p-6 lg:col-span-1">
        <div className="eyebrow">// Framework</div>
        <h2 className="display-md text-silver-50 mt-2">11 Stages</h2>
        <ol className="mt-5 space-y-2">
          {SPARK_STAGES.map((s) => (
            <li key={s.n} className="flex items-center gap-3">
              <div className={`h-7 w-7 rounded-sm flex items-center justify-center font-mono text-xs ${
                s.n < 8 ? "bg-brand-blue text-white" : s.n === 8 ? "bg-brand-blue/30 text-brand-blue animate-pulseGlow" : "bg-ink-700 text-silver-300"
              }`}>{s.n}</div>
              <div className="text-sm text-silver-100">{s.name}</div>
            </li>
          ))}
        </ol>
      </div>
      <div className="panel-hi p-6 lg:col-span-2 flex flex-col min-h-[560px]">
        <div className="flex items-center gap-2">
          <Sparkles className="text-brand-blue" size={18} />
          <div className="eyebrow !text-brand-blue">// Ask Spark · Stage 8 — Sitemap & Wireframe</div>
        </div>
        <div className="flex-1 mt-4 space-y-4 overflow-auto">
          <Msg who="spark">
            Based on your ICP (anxious-first dental patients 30–55) and your USP ("same-day crowns, judgment-free"), I'm proposing a 7-page sitemap centered on a <strong>Trust-First</strong> layout. Want me to show the wireframe?
          </Msg>
          <Msg who="client">Yes — and add a "Financing" page, we keep getting that question.</Msg>
          <Msg who="spark">Added. Financing slots in under Services as a sub-page with its own FAQ block for AEO. Want the wireframe in low-fi first or jump to high-fi mockup?</Msg>
        </div>
        <div className="mt-4 flex gap-2">
          <input className="flex-1 rounded-md border border-ink-700 bg-ink-900 px-4 py-3 text-silver-100 focus:border-brand-blue focus:outline-none" placeholder="Ask Spark anything about your brand…" />
          <button className="btn-primary"><Send size={14} /> Send</button>
        </div>
      </div>
    </div>
  );
}

function Msg({ who, children }: { who: "spark" | "client"; children: React.ReactNode }) {
  const isSpark = who === "spark";
  return (
    <div className={`flex ${isSpark ? "justify-start" : "justify-end"}`}>
      <div className={`max-w-[80%] rounded-lg p-4 text-sm leading-relaxed ${
        isSpark ? "bg-ink-800 border border-brand-blue/30 text-silver-100" : "bg-brand-blue text-white"
      }`}>
        {children}
      </div>
    </div>
  );
}
